import {Injectable} from '@angular/core';
import {CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {Observable, Observer, of} from 'rxjs';
import {NonceAuthService} from '../auth/nonce-auth.service';
import {switchMap} from 'rxjs/operators';
import {StateStorageService} from '../services/state-storage.service';
import {NavController, ToastController} from '@ionic/angular';
import {CommonFunctionsService} from '../services/common-functions.service';
import {APP_ENGINE_WAIT_RETRIES, APP_ENGINE_WAIT_TIME} from '../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class AuthGuard implements CanActivate {

    private denialMessage: string = '';

    constructor(private navController: NavController,
                private authService: NonceAuthService,
                private appState: StateStorageService,
                private commonFunctions: CommonFunctionsService,
                private toastController: ToastController) {

        this.commonFunctions.getSingleTranslation('auth.denied')
            .then((value: string) => this.denialMessage = value);
    }

    canActivate(route: ActivatedRouteSnapshot,
                state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        let roles: string[] = [];
        if (route.data && route.data['access']) roles = route.data['access'];
        return this.authService.isLoggedIn().pipe(
            switchMap((res: any) => {
                if (res) return this.checkUserRole(roles);
                else {
                    // noinspection JSIgnoredPromiseFromCall
                    this.navController.navigateRoot('/login', {queryParams: {returnUrl: state.url}});
                    return of(false);
                }
            })
        );
    }

    checkUserRole(authRoles: string[], tries: number = APP_ENGINE_WAIT_RETRIES): Observable<boolean> {
        return new Observable<boolean>((observer) => {
            this.doCheckUserRole(authRoles, APP_ENGINE_WAIT_RETRIES, APP_ENGINE_WAIT_TIME, observer);
        });
    }

    doCheckUserRole(authRoles: string[], tries: number, wait: number, observer: Observer<boolean>): boolean {
        if (this.appState.authData) {
            const res = this.commonFunctions.hasAuthRole(authRoles, this.appState.authData.role);
            if (null !== res) {
                if (!res) this.showDenial();
                observer.next(res);
                observer.complete();
                return res;
            }
        }
        if (0 < tries) {
            setTimeout(() => {
                return this.doCheckUserRole(authRoles, tries - 1, wait, observer);
            }, wait);
        }
        return false;
    }

    showDenial() {
        console.log('Toast Denial: ' + this.denialMessage);
        console.trace();
        this.toastController.create({
            message: this.denialMessage,
            duration: 4000,
            cssClass: 'preLineWhitespace'
        }).then((toast) => {
            toast.present();
        });

    }
}
